var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z",
    fill: "url(#paint0_linear_1_2355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 43.5C25.9998 41.4 24.2998 39.8 22.2998 39.8C21.3233 39.8155 20.3912 40.2103 19.7006 40.9009C19.0101 41.5914 18.6153 42.5236 18.5998 43.5C18.5998 45.6 20.2998 47.2001 22.2998 47.2001C24.2998 47.2001 25.9998 45.6 25.9998 43.5ZM53.4998 43.5C53.4998 41.4 51.7998 39.8 49.7998 39.8C47.6998 39.8 46.0998 41.5 46.0998 43.5C46.0998 45.6 47.7998 47.2001 49.7998 47.2001C51.7998 47.2001 53.4998 45.6 53.4998 43.5ZM35.9998 44.7001C33.6932 44.7027 31.4819 45.6202 29.8509 47.2511C28.2199 48.8821 27.3025 51.0935 27.2998 53.4001V56C27.2998 56.7001 27.8998 57.2001 28.4998 57.2001H43.4998C44.1998 57.2001 44.6998 56.6 44.6998 56V53.5C44.6998 48.7001 40.7998 44.7001 35.9998 44.7001ZM40.9998 39.7001C41.0065 39.0416 40.8817 38.3884 40.6328 37.7788C40.3839 37.1691 40.0159 36.6152 39.5502 36.1496C39.0846 35.684 38.5308 35.3159 37.9211 35.067C37.3115 34.8181 36.6583 34.6934 35.9998 34.7001C35.3413 34.6934 34.6882 34.8181 34.0785 35.067C33.4689 35.3159 32.915 35.684 32.4494 36.1496C31.9837 36.6152 31.6157 37.1691 31.3668 37.7788C31.1179 38.3884 30.9931 39.0416 30.9998 39.7001C30.9931 40.3585 31.1179 41.0117 31.3668 41.6213C31.6157 42.231 31.9837 42.7849 32.4494 43.2505C32.915 43.7161 33.4689 44.0842 34.0785 44.3331C34.6882 44.582 35.3413 44.7067 35.9998 44.7001C36.6583 44.7067 37.3115 44.582 37.9211 44.3331C38.5308 44.0842 39.0846 43.7161 39.5502 43.2505C40.0159 42.7849 40.3839 42.231 40.6328 41.6213C40.8817 41.0117 41.0065 40.3585 40.9998 39.7001ZM49.6998 47.2001C48.354 47.196 47.0353 47.5777 45.8998 48.3C46.6998 49.9 47.1998 51.6 47.1998 53.5V56C47.1903 56.4075 47.123 56.8116 46.9998 57.2001H55.9998C56.6998 57.2001 57.1998 56.6 57.1998 56V54.8C57.1998 50.6 53.8998 47.2001 49.6998 47.2001ZM26.0998 48.3C24.9643 47.5777 23.6456 47.196 22.2998 47.2001C18.1998 47.2001 14.7998 50.6001 14.7998 54.7001V56C14.7998 56.7001 15.3998 57.2001 15.9998 57.2001H24.9998C24.8998 56.8 24.7998 56.4001 24.7998 56V53.5C24.7998 51.6 25.2998 49.9 26.0998 48.3ZM23.4998 37.2001C26.4998 37.2001 28.9998 35.1 29.5998 32.2001H45.9998C48.0998 32.2001 49.6998 30.5 49.6998 28.5V18.5C49.6998 16.4 47.9998 14.8 45.9998 14.8H25.9998C23.8998 14.8 22.2998 16.5 22.2998 18.5V36C22.2998 36.7001 22.7998 37.2001 23.4998 37.2001ZM30.9998 19.8H40.9998C41.6998 19.8 42.1998 20.4 42.1998 21C42.1998 21.7 41.5998 22.2 40.9998 22.2H30.9998C30.2998 22.2 29.7998 21.6 29.7998 21C29.7998 20.3 30.2998 19.8 30.9998 19.8ZM30.9998 24.8H40.9998C41.6998 24.8 42.1998 25.4 42.1998 26C42.1998 26.7 41.5998 27.2 40.9998 27.2H30.9998C30.2998 27.2 29.7998 26.6 29.7998 26C29.7998 25.3 30.2998 24.8 30.9998 24.8Z",
    fill: "url(#paint1_linear_1_2355)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2355",
    x1: 36,
    y1: 72,
    x2: 36,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2355",
    x1: 35.9998,
    y1: 14.766,
    x2: 35.9998,
    y2: 57.2341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI1);
export default __webpack_public_path__ + "static/media/i1.c02e16ab4893065a42e0fd03665ac3fa.svg";
export { ForwardRef as ReactComponent };